import * as angular from "angular";
import {StudyProgram} from "../../models/study-program.model";
import {ApiUrl} from "../../models/app-config.model";
import {SubscriptionStudyPrograms} from "../../models/subscription-study-programs.model";
import {CurrentUser} from "../../models/user/user.model";
import {UserService} from "../user/user.service";

const CACHE_STUDY_PROGRAMS = "CACHE_STUDY_PROGRAMS";
const COMMAND_UPDATE_STUDY_PROGRAMS = "UPDATE_STUDY_PROGRAMS";

const NON_AP_COURSES = ["nav-act-aspire-prep", "nav-act-english-reading-writing-prep", "nav-act-math-prep",
    "nav-workkeys", "naviance-act-2025-prep", "nav-sat-prep-24"];

export interface StudyProgramsService {
    clearStudyProgramsCache(): void;
    getStudyPrograms: (tenantId: string, subscribed?: boolean) => angular.IPromise<StudyProgram[]>;
    getSubscriptionStudyPrograms: (tenantId: string, apOnly?: boolean) => angular.IPromise<SubscriptionStudyPrograms>;
    updateStudyProgramsSubscription: (studyPrograms: StudyProgram[], activatedCount: number, tenantId?: string) => angular.IPromise<number>;
}

/* @ngInject */
export function studyProgramsService(API_URL: ApiUrl, $http: angular.IHttpService, $q: angular.IQService,
                                     userService: UserService, $cacheFactory: angular.ICacheFactoryService,
                                     PRODUCT: string): StudyProgramsService {
    let dataCache = $cacheFactory(CACHE_STUDY_PROGRAMS);

    let clearDataCache = () => {
        dataCache.removeAll();
    };

    let isApCourse = (studyProgram: StudyProgram): boolean => {
        return studyProgram && studyProgram.courseSlug && NON_AP_COURSES.indexOf(studyProgram.courseSlug) === -1;
    };

    return {
        clearStudyProgramsCache:(): void => {
            clearDataCache();
        },
        getStudyPrograms: (tenantId: string, subscribed?: boolean): angular.IPromise<StudyProgram[]> => {
            return $http.get(`${API_URL.studyPrograms}?query=${JSON.stringify({ tenantId: tenantId })}`, {cache: dataCache})
                .then((response: { data: SubscriptionStudyPrograms }) => {
                        if (subscribed) {
                            return response.data.studyPrograms.filter((program: StudyProgram) => program.subscribed);
                        }
                        return response.data.studyPrograms;
                    }, (errorResponse) => {
                        if (errorResponse && errorResponse.status === 404) {
                            return [];
                        } else {
                            return $q.reject(errorResponse);
                        }
                    });
        },
        getSubscriptionStudyPrograms: (tenantId: string, apOnly?: boolean): angular.IPromise<SubscriptionStudyPrograms> => {
            return $http.get(`${API_URL.studyPrograms}?query=${JSON.stringify({ tenantId: tenantId })}`, {cache: dataCache})
                .then((response: { data: SubscriptionStudyPrograms }) => {
                        if(apOnly) {
                            response.data.studyPrograms = response.data.studyPrograms.filter(isApCourse);
                        }
                        return response.data;
                    }, (errorResponse) => {
                        if (errorResponse && errorResponse.status === 404) {
                            return {};
                        } else {
                            return $q.reject(errorResponse);
                        }
                    });
        },
        updateStudyProgramsSubscription: (studyPrograms, activatedCount, tenantId?): angular.IPromise<number> => {
            return userService.get().then((currentUser: CurrentUser) => {
                let data = {
                    command: COMMAND_UPDATE_STUDY_PROGRAMS,
                    product: PRODUCT,
                    studyPrograms: studyPrograms,
                    activatedCount: activatedCount,
                    tenantId: tenantId || currentUser.tenantId
                };

                let headers = {"Content-Type": "application/json"};
                return $http.post(`${API_URL.studyPrograms}/command`, data, headers)
                    .then((response) => {
                        clearDataCache();
                        return response.status;
                    });
            });
        }
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/study-programs/study-programs.service.ts
 **/